import React, { createContext, useCallback, useMemo, useState } from 'react';

const TOKEN_KEY = 'anylex_token';
const REFRESH_TOKEN_KEY = 'anylex_refresh_token';

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
    const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem(REFRESH_TOKEN_KEY));
    const [user, setUser] = useState(null);

    const login = useCallback((authData) => {
        const accessToken = typeof authData === 'string'
            ? authData
            : (authData?.access_token || '');
        const nextRefreshToken = typeof authData === 'string'
            ? ''
            : (authData?.refresh_token || '');

        localStorage.setItem(TOKEN_KEY, accessToken);
        setToken(accessToken);

        if (nextRefreshToken) {
            localStorage.setItem(REFRESH_TOKEN_KEY, nextRefreshToken);
            setRefreshToken(nextRefreshToken);
        } else {
            localStorage.removeItem(REFRESH_TOKEN_KEY);
            setRefreshToken(null);
        }
    }, []);

    const updateTokens = useCallback((authData) => {
        if (!authData?.access_token || !authData?.refresh_token) {
            return;
        }
        login(authData);
    }, [login]);

    const logout = useCallback(() => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        setToken(null);
        setRefreshToken(null);
        setUser(null);
    }, []);

    const isAuthenticated = !!token;

    const value = useMemo(() => ({
        token,
        refreshToken,
        user,
        setUser,
        login,
        updateTokens,
        logout,
        isAuthenticated,
    }), [token, refreshToken, user, login, updateTokens, logout, isAuthenticated]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}
